// Mock data for Bold AI Personal Coach Website
export const mockData = {
  // Hero section content
  hero: {
    title: "UNLOCK YOUR POTENTIAL. ANYTIME. ANYWHERE.",
    subtitle: "Your AI Coach pushes you to go further — in fitness, mindset, and life.",
    ctaPrimary: "START FREE",
    ctaSecondary: "SEE HOW IT WORKS"
  },

  // Motivation marquee text
  motivationMarquee: [
    "DISCIPLINE",
    "ENERGY", 
    "CONFIDENCE",
    "SUCCESS",
    "POWER",
    "FOCUS",
    "STRENGTH",
    "TRANSFORMATION"
  ],

  // App screens for showcase with bold one-liners
  appScreens: [
    {
      id: 1,
      title: "CRUSH YOUR FITNESS GOALS",
      description: "AI-powered workouts that adapt and challenge you daily",
      image: "https://images.unsplash.com/photo-1688114361871-1610cb1d51ea?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHw0fHxmaXRuZXNzJTIwbW90aXZhdGlvbnxlbnwwfHx8fDE3NTg4NzgzOTB8MA&ixlib=rb-4.1.0&q=85"
    },
    {
      id: 2,
      title: "BOOST YOUR CONFIDENCE",
      description: "Master dating and social situations with AI guidance",
      image: "https://images.unsplash.com/photo-1483721310020-03333e577078?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwyfHxmaXRuZXNzJTIwbW90aXZhdGlvbnxlbnwwfHx8fDE3NTg4NzgzOTB8MA&ixlib=rb-4.1.0&q=85"
    },
    {
      id: 3,
      title: "STAY FOCUSED. STAY CONSISTENT.",
      description: "Productivity systems that eliminate excuses",
      image: "https://images.unsplash.com/photo-1596773544141-798fc586f31e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwxfHx3ZWxsbmVzcyUyMGxpZmVzdHlsZXxlbnwwfHx8fDE3NTg4NzgzOTV8MA&ixlib=rb-4.1.0&q=85"
    },
    {
      id: 4,
      title: "DOMINATE YOUR MINDSET",
      description: "Mental training for unstoppable success",
      image: "https://images.unsplash.com/photo-1615629748241-97efffef4ed2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHw0fHx3ZWxsbmVzcyUyMGxpZmVzdHlsZXxlbnwwfHx8fDE3NTg4NzgzOTV8MA&ixlib=rb-4.10&q=85"
    }
  ],

  // Power features - "Why It Works"
  powerFeatures: [
    {
      id: 1,
      icon: "Zap",
      title: "INSTANT AI FEEDBACK",
      description: "Real-time coaching that adapts to your performance"
    },
    {
      id: 2,
      icon: "Brain",
      title: "SMARTER ROUTINES",
      description: "AI creates personalized plans that evolve with you"
    },
    {
      id: 3,
      icon: "Flame",
      title: "MOTIVATION ON-DEMAND",
      description: "24/7 accountability partner that never gives up on you"
    },
    {
      id: 4,
      icon: "TrendingUp",
      title: "REAL PROGRESS TRACKING",
      description: "Data-driven insights that prove your transformation"
    }
  ],

  // Bold testimonials/transformations
  transformations: [
    {
      id: 1,
      name: "MARCUS J.",
      role: "SOFTWARE ENGINEER",
      image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBoZWFkc2hvdHN8ZW58MHx8fHwxNzU4ODc4NDIxfDA&ixlib=rb-4.1.0&q=85",
      quote: "I'VE NEVER BEEN THIS CONSISTENT IN MY WORKOUTS. THE AI COACH CHANGED MY LIFE.",
      result: "Lost 25 lbs in 3 months"
    },
    {
      id: 2,
      name: "SARAH C.",
      role: "ENTREPRENEUR", 
      image: "https://images.unsplash.com/photo-1657128344786-360c3f8e57e5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjBoZWFkc2hvdHN8ZW58MHx8fHwxNzU4ODc4NDIxfDA&ixlib=rb-4.1.0&q=85",
      quote: "MY PRODUCTIVITY DOUBLED AND MY CONFIDENCE SKYROCKETED. THIS ISN'T JUST AN APP.",
      result: "2x productivity increase"
    },
    {
      id: 3,
      name: "DAVID R.",
      role: "SALES MANAGER",
      image: "https://images.unsplash.com/photo-1629425733761-caae3b5f2e50?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwzfHxwcm9mZXNzaW9uYWwlMjBoZWFkc2hvdHN8ZW58MHx8fHwxNzU4ODc4NDIxfDA&ixlib=rb-4.1.0&q=85",
      quote: "FROM FITNESS TO DATING TO BUSINESS - THE AI COACH TRANSFORMED EVERY AREA OF MY LIFE.",
      result: "Complete life transformation"
    }
  ],

  // Aggressive pricing plans
  pricingPlans: [
    {
      id: 1,
      name: "FREE",
      price: 0,
      period: "FOREVER",
      popular: false,
      features: [
        "Daily check-ins",
        "Basic AI coaching",
        "10 chat sessions/month", 
        "Community access",
        "Progress tracking"
      ]
    },
    {
      id: 2,
      name: "PRO",
      price: 29,
      period: "MONTH",
      popular: true,
      features: [
        "UNLIMITED AI coaching", 
        "Personalized fitness plans",
        "Dating & confidence boost",
        "Productivity optimization",
        "Advanced analytics",
        "Priority support",
        "Weekly challenges"
      ]
    },
    {
      id: 3,
      name: "PREMIUM",
      price: 99,
      period: "MONTH",
      popular: false,
      features: [
        "Everything in Pro",
        "1-on-1 AI strategy sessions",
        "Custom transformation program",
        "Video coaching sessions",
        "Life mastery courses",
        "VIP community access",
        "Guaranteed results"
      ]
    }
  ],

  // Power statistics
  stats: {
    consistency: "10X",
    focus: "90%", 
    breakthroughs: "75%",
    availability: "24/7"
  },

  // Final CTA
  finalCTA: {
    title: "THE FUTURE OF COACHING IS HERE.",
    subtitle: "Stop making excuses. Your transformation starts NOW.",
    cta: "START FREE TODAY"
  }
};

// Mock AI chat messages for demo
export const mockChatMessages = [
  {
    id: 1,
    type: 'ai',
    text: "Ready to CRUSH today's goals? Let's build that discipline muscle! 💪",
    timestamp: new Date()
  },
  {
    id: 2,
    type: 'user', 
    text: "I need motivation for my workout",
    timestamp: new Date()
  },
  {
    id: 3,
    type: 'ai',
    text: "BOOM! You showed up - that's 80% of success right there. Now let's make those weights FEAR you! What's your energy level 1-10?",
    timestamp: new Date()
  }
];